import LandingNav from "./components/LandingNav";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import CompanyTypesSection from "./components/CompanyTypesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import TestimonialsSection from "./components/TestimonialsSection";
import SignupSection from "./components/SignupSection";
import FooterSection from "./components/FooterSection";

// Pretendard Variable — 한글/영문/숫자 통합
const PRETENDARD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function LandingPage() {
  return (
    <div
      className="min-h-screen bg-white"
      style={{ fontFamily: PRETENDARD }}
    >
      <LandingNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CompanyTypesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <SignupSection />
      </main>
      <FooterSection />
    </div>
  );
}
